import { render, staticRenderFns } from "./LiquidacionComprobanteModal.vue?vue&type=template&id=70d0af6c"
import script from "./LiquidacionComprobanteModal.vue?vue&type=script&lang=js"
export * from "./LiquidacionComprobanteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports